<div
  class="refresh-wrapper d-flex flex-row-reverse align-items-center pointer"
  [delay]="500"
  [action]="'leave'"
  (smHesitate)="hesitateMenu.hesitateStatus && showMenu.set(false)"
  [class.show-menu]="showMenu()"
>
  <button
    mat-icon-button
    class="refresh"
    data-id="Auto Refresh"
    (click)="$event.preventDefault(); refresh()"
    [delay]="300"
    [action]="'enter'"
    (smHesitate)="showMenu.set(true); hesitateMenu.hesitateStatus=true"
  >
    <span class="arrows" [class.rotate]="rotate()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path class="path_arrows" d="M13.79,19.79l1.61,1.61c-1.06.38-2.2.6-3.4.6-5.52,0-10-4.48-10-10,0-1.97.58-3.8,1.56-5.35l-.93-.93c-.27-.27-.08-.72.3-.72h3.64c.23,0,.42.19.42.42v3.64c0,.38-.46.57-.72.3l-1.25-1.25c-.65,1.15-1.02,2.48-1.02,3.89,0,4.41,3.59,8,8,8,.62,0,1.21-.08,1.79-.21ZM20.03,17.94c1.23-1.66,1.97-3.71,1.97-5.94,0-5.52-4.48-10-10-10-1.19,0-2.33.22-3.4.6l1.61,1.61c.58-.13,1.17-.21,1.79-.21,4.41,0,8,3.59,8,8,0,1.67-.52,3.22-1.4,4.51l-.87-.87c-.27-.27-.72-.08-.72.3v3.64c0,.23.19.42.42.42h3.64c.38,0,.57-.46.3-.72l-1.34-1.34Z" fill="#8492c2"/>
        </svg>
    </span>
    @if (allowAutoRefresh()) {
      @if (autoRefreshState()) {
        <span class="play">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path class="path_play" d="M14.89,12.29l-3.99,3.05c-.33.26-.9.07-.9-.29v-6.09c0-.36.57-.54.9-.29l3.99,3.05c.15.14.15.44,0,.57Z" fill="#d3ff00"/>
            </svg>
        </span>
      } @else {
        <span class="pause">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path class="path_pause" d="M15,10v4c0,.55-.45,1-1,1s-1-.45-1-1v-4c0-.55.45-1,1-1s1,.45,1,1ZM10,9c-.55,0-1,.45-1,1v4c0,.55.45,1,1,1s1-.45,1-1v-4c0-.55-.45-1-1-1Z" fill="#c9f300" />
            </svg>
        </span>
      }
    }
  </button>
  <div
    class="tooltip-container"
    [delay]="500"
    [action]="'leave'"
    (smHesitate)="showMenu.set(false)"
    #hesitateMenu="hesitate"
  >
    @if (showMenu()) {
      <mat-slide-toggle
        animate.enter="enter" animate.leave="leaving"
        [ngModel]="autoRefreshState()"
        (ngModelChange)="setAutoRefresh.emit($event)"
      >
        <span class="toggle-label" [class.enabled]="autoRefreshState()">AUTO REFRESH</span>
      </mat-slide-toggle>
      <div class="dot" animate.enter="enter" animate.leave="leaving">•</div>
      <button mat-button (click)="refresh()" animate.enter="enter" animate.leave="leaving">REFRESH</button>
    }
  </div>
  @if (showMenu()) {
    <div animate.enter="enter" animate.leave="leaving" class="tip"></div>
  }
</div>
